<template>
  <div
    v-tooltip="tooltip"
    class="post-icon-and-text-metric"
  >
    <StIcon
      :icon-name="icon"
      color="var(--default-text-color)"
    />
    <div class="text-truncate">
      {{ formatNumber(value) }}
    </div>
  </div>
</template>

<script>
import { formatNumber } from '@/utils/formatter';
import StIcon from '@stilingue/st-icon';
import { iconMap } from '@/utils/icon-map';

export default {
  name: 'PostIconAndTextMetric',
  components: {
    StIcon,
  },
  props: {
    metric: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    icon() {
      return iconMap(this.metric).icon;
    },
    tooltip() {
      return `${this.formatNumber(this.value)} ${iconMap(this.metric).name}`;
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<style scoped lang="scss">
  .post-icon-and-text-metric {
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    align-items: center;
    text-align: center;

    div {
      text-align: center;
    }

    .text-truncate {
      font-size: 0.75em;
    }
  }
</style>
